
<NBackdrop :coverSnackbars="coverSnackbars" :fadeAway="!open" :suppressed="suppressed">
  <transition appear name="modal-animation">
    <div v-if="open" class="modal-layout" @mousedown.self="closeOnOutside && close()">
      <slot></slot>
    </div>
  </transition>
</NBackdrop>
